/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ConfirmationsInputs */

const en_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmations`)
};

const ar_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التأكيدات`)
};

const bn_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিশ্চিতকরণ`)
};

const de_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungen`)
};

const es_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmaciones`)
};

const fr_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmations`)
};

const pt_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmações`)
};

const zh_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认通知`)
};

const tr_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onaylar`)
};

const ru_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтверждения`)
};

const pl_svchip_confirmations = /** @type {(inputs: Svchip_ConfirmationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdzenia`)
};

/**
* | output |
* | --- |
* | "Confirmations" |
*
* @param {Svchip_ConfirmationsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_confirmations = /** @type {((inputs?: Svchip_ConfirmationsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ConfirmationsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_confirmations(inputs)
	if (locale === "bn") return bn_svchip_confirmations(inputs)
	if (locale === "de") return de_svchip_confirmations(inputs)
	if (locale === "es") return es_svchip_confirmations(inputs)
	if (locale === "fr") return fr_svchip_confirmations(inputs)
	if (locale === "pt") return pt_svchip_confirmations(inputs)
	if (locale === "zh") return zh_svchip_confirmations(inputs)
	if (locale === "tr") return tr_svchip_confirmations(inputs)
	if (locale === "ru") return ru_svchip_confirmations(inputs)
	if (locale === "pl") return pl_svchip_confirmations(inputs)
	return en_svchip_confirmations(inputs)
});